import { apiInterfaceForJson } from "../common/apiManager";

export const fetchEmailTemplates = () => {
    return apiInterfaceForJson("/email-template/v1/", "GET");
};

export const createEmailTemplate = (data) => {
    return apiInterfaceForJson("/email-template/v1/", "POST", data);
};

export const updateEmailTemplate = (data) => {
    return apiInterfaceForJson("/email-template/v1/", "PUT", data);
};

export const deleteEmailTemplate = (id) => {
    return apiInterfaceForJson("/email-template/v1/delete", "POST", { _id: id });
};

const AI_TIMEOUT = 300000; // AI generation can take a while

export const assistantEmailTemplate = (messages, currentDraft) => {
    return apiInterfaceForJson(
        "/email-template/v1/assistant",
        "POST",
        { messages, currentDraft },
        undefined,
        AI_TIMEOUT
    );
};
